var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcPort12X14(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_-_evse",
    "data-name": "icon - evse",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.999,
    height: 12.299,
    viewBox: "0 0 13.999 12.299",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4d4d4f;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon_-_evse-2",
    "data-name": "icon - evse",
    className: "cls-1",
    d: "M5.893,12.3H2.947V10.882H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0H6.842a2,2,0,0,1,2,2V6.832h.737A1.613,1.613,0,0,1,11.186,8.44v1.7a.8.8,0,1,0,1.607,0V6.261a2.058,2.058,0,0,1-.8.169,2.007,2.007,0,0,1-.715-3.883l-1.7-1.7L10.43,0l2.991,2.99L13.413,3A2.012,2.012,0,0,1,14,4.421v5.723a2.01,2.01,0,1,1-4.019,0V8.038H8.842v.844a2,2,0,0,1-2,2H5.894V12.3h0ZM2.653,6.286H3.779V8.818l2.252-3.94H4.905V2.064Zm8.533-1.865a.8.8,0,1,0,.8-.8A.806.806,0,0,0,11.186,4.421Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPort12X14);
export default __webpack_public_path__ + "static/media/ic_port_12x14.2744579ec2b03eddcbaff36193f76665.svg";
export { ForwardRef as ReactComponent };